import React from "react";

const NetworkDeviceContentIconHelper = ({type}) => {
    let icon = null;
    switch(type) {
        case "video-player":
        case "video-player-avalonia":
            icon = 'fa-video';
            break;
        case "audio-player":
            icon = "fa fa-headphones"
            break;
        case "kiosk-application":
            icon = 'fa-atom';
            break;
        default:
            icon = 'fa-rocket';
    }

    return (
        <i className={ "fas " + icon }> </i>
    )
}
export default NetworkDeviceContentIconHelper;
